import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { API_BASE_URL } from "../../../Helpers/apiConfig";

const PackagePrice = () => {
    const { t } = useTranslation();
    const { user, refreshUser } = useAuth();
    const navigate = useNavigate();

    const [loadingg, setLoadingg] = useState(true);
    const [packages, setPackages] = useState([]);
    const [msg, setMsg] = useState("");

    const [selectedPackage, setSelectedPackage] = useState(null);
    const [paymentChoice, setPaymentChoice] = useState(null);
    const [couponCode, setCouponCode] = useState("");
    const [submittingCoupon, setSubmittingCoupon] = useState(false);
    const [modalMsg, setModalMsg] = useState("");

    const headerss = {
        accept: "*/*",
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": "false",
        Authorization: "Bearer " + user.token
    };

    const fetchDataPackages = async () => {
        setLoadingg(true);

        try {
            const pakcageUrl = API_BASE_URL + "/User/GetPackages";
            const courseUrl = API_BASE_URL + "/User/Content/GetCourse"; // user yerine User dene
            const sectionUrl = API_BASE_URL + "/user/Opt/GetSection";
            const [packageRes, courseRes, sectionRes] = await Promise.all([
                axios.get(pakcageUrl, { headers: headerss }),
                axios.get(courseUrl, { headers: headerss }),
                axios.get(sectionUrl, { headers: headerss })
            ]);
            console.log("Package Response:", packageRes);
            console.log("section Response:", sectionRes);
            if (!(packageRes.status === 200 && packageRes.data.success)) {
                setMsg(packageRes.data.message || t("unexpectedError"));
                setLoadingg(false);
                return;
            }

            const courseMap = {};

            if (courseRes.status === 200 && courseRes.data.success) {
                const courseList = courseRes.data?.data?.courses || [];
                courseList.forEach((course) => {
                    courseMap[String(course.id)] = {
                        name: course.courseName,
                        desc: course.courseDesc
                    };
                });
            }

            const sectionMap = {};

            if (sectionRes.status === 200 && sectionRes.data.success) {
                const sectionList = sectionRes.data?.data?.sections || [];
                sectionList.forEach((section) => {
                    sectionMap[String(section.id)] = {
                        name: section.sectionName,
                        desc: section.sectionDescription
                    };
                });
            }

            const filteredPackages = [];
            const packageList = packageRes.data?.data || [];

            for (let i = 0; i < packageList.length; i++) {
                const p = packageList[i];

                if (!p.isActive) continue;

                if (
                    (user.role === "Yönetici" && !p.isInvidual) ||
                    (user.role === "Öğrenci" && p.isInvidual)
                ) {
                    const referenceMap = p.isInvidual ? courseMap : sectionMap;
                    filteredPackages.push({
                        id: p.id,
                        isInvidual: p.isInvidual,
                        packageName: p.packageName,
                        packageDetail: p.packageDetail,
                        packagePrice: p.packagePrice,
                        howManyDays: p.howManyDays,
                        courseName: referenceMap[String(p.sortNumber)]?.name || "-",
                        courseDesc: referenceMap[String(p.sortNumber)]?.desc || "-"
                    });
                }
            }
            setPackages(filteredPackages);
        } catch (err) {
            console.log("API ERROR:", err.response?.status, err.response?.data, err.config?.url);
            setMsg(err.response?.data?.message || err.message || t("unexpectedError"));
        }

        setLoadingg(false);
    };

    useEffect(() => {
        //getPackages();
        fetchDataPackages();
    }, []);

    const handleBuyClick = (pkg) => {
        setSelectedPackage(pkg);
        setPaymentChoice(null);
        setCouponCode("");
        setModalMsg("");
    };

    const handleManagerBuy = async (pkg) => {
        try {
            const res = await axios.post(
                API_BASE_URL + "/manager/Subscription/Apply",
                {
                    gatewayId: 1,
                    package: pkg.id,
                },
                { headers: headerss }
            );

            if (res.data.success) {
                Swal.fire("Başarılı", "Ödeme talebiniz alınmıştır", "success");
            } else {
                Swal.fire("Hata", res.data.message, "error");
            }
        } catch (err) {
            Swal.fire("Hata", err.message, "error");
        }
    };

    const handleCloseModal = () => {
        setSelectedPackage(null);
        setPaymentChoice(null);
        setCouponCode("");
        setModalMsg("");
    };

    const handleChooseCard = () => {
        navigate(`/profile/odemetest/${selectedPackage.id}/${selectedPackage.packagePrice}`);
    };

    const handleSubmitCoupon = async (e) => {
        e.preventDefault();
        setSubmittingCoupon(true);
        setModalMsg("");

        try {
            const res = await axios.post(
                API_BASE_URL + "/user/Subscription/ApplyCupon",
                {
                    packageId: selectedPackage.id,
                    cuponCode: couponCode,
                },
                { headers: headerss }
            );

            if (res.data.success) {
                await refreshUser();
                Swal.fire("Başarılı", "Satın alma işleminiz başarıyla tamamlanmıştır.", "success");
                handleCloseModal();
            } else {
                setModalMsg(res.data.message);
            }
        } catch (err) {
            setModalMsg(err.message);
        }
        setSubmittingCoupon(false);
    };

    return (
        <div className="container my-4 my-md-5">
            <div className="card shadow-sm border-0">
                <div className="card-body p-3 p-md-4">
                    <h3 className="text-center mb-2">{t("packages&prices")}</h3>
                    <p className="text-center text-muted mb-4">{t("packagesList")}</p>

                    {loadingg && (
                        <div className="alert alert-info text-center">
                            {t("loading")}...
                        </div>
                    )}

                    {!loadingg && msg && (
                        <div className="alert alert-warning text-center">
                            {msg}
                        </div>
                    )}

                    {/* Telefonda tablo sığmıyor (sütun genişlikleri ~790px): md altı ekranlarda kart listesi */}
                    {!loadingg && !msg && (
                        <div className="d-md-none">
                            {packages.map((dt) => (
                                <div key={dt.id} className="border rounded-3 p-3 mb-3">
                                    <div className="fw-bold mb-1">
                                        <span dangerouslySetInnerHTML={{ __html: dt.courseName }} />
                                    </div>
                                    <div className="small text-muted mb-2">
                                        <span dangerouslySetInnerHTML={{ __html: dt.courseDesc }} />
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        <span className="small">{t("validityDate")}: <strong>{dt.howManyDays}</strong></span>
                                        <span className="text-nowrap">
                                            <span className="badge bg-success fs-6">{dt.packagePrice} ₺</span>
                                            <em className="small text-muted ms-1">(KDV Dahil)</em>
                                        </span>
                                    </div>
                                    <button
                                        className="btn btn-primary w-100"
                                        onClick={() => dt.isInvidual ? handleBuyClick(dt) : handleManagerBuy(dt)}
                                    >
                                        Satın Al
                                    </button>
                                </div>
                            ))}
                            {packages.length === 0 && (
                                <div className="alert alert-light text-center mb-0">
                                    {t("noData") || "Kayıt bulunamadı."}
                                </div>
                            )}
                        </div>
                    )}

                    {!loadingg && !msg && (
                        <div className="table-responsive d-none d-md-block">
                            <table className="table table-hover table-bordered align-middle">
                                <thead className="table-light">
                                    <tr>
                                        <th style={{ minWidth: "180px" }}>{user.role === "Yönetici" ? "Bölüm Adı" : "Kurs Adı"}</th>
                                        <th style={{ minWidth: "220px" }}>{user.role === "Yönetici" ? "Bölüm Açıklaması" : "Kurs Açıklaması"}</th>
                                        <th style={{ minWidth: "130px" }}>{t("validityDate")}</th>
                                        <th style={{ minWidth: "130px" }}>{t("packagePrice")}</th>
                                        <th style={{ minWidth: "130px" }}>İşlem</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {packages.map((dt) => (
                                        <tr key={dt.id}>
                                            <td>
                                                <span dangerouslySetInnerHTML={{ __html: dt.courseName }} />
                                            </td>
                                            <td>
                                                <span dangerouslySetInnerHTML={{ __html: dt.courseDesc }} />
                                            </td>
                                            <td>{dt.howManyDays}</td>
                                            <td>
                                                <span className="badge bg-success fs-6">
                                                    {dt.packagePrice} ₺
                                                </span>
                                                <em className="small text-muted ms-1 text-nowrap">(KDV Dahil)</em>
                                            </td>
                                            <td>
                                                <button
                                                    className="btn btn-primary btn-sm"
                                                    onClick={() => dt.isInvidual ? handleBuyClick(dt) : handleManagerBuy(dt)}
                                                >
                                                    Satın Al
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                            {packages.length === 0 && (
                                <div className="alert alert-light text-center mb-0">
                                    {t("noData") || "Kayıt bulunamadı."}
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>

            {selectedPackage && (
                <div className="modal fade show" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }} tabIndex="-1" role="dialog">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    <span dangerouslySetInnerHTML={{ __html: selectedPackage.courseName }} /> - {selectedPackage.packagePrice} ₺ <em className="small text-muted">(KDV Dahil)</em>
                                </h5>
                                <button type="button" className="btn-close" onClick={handleCloseModal}></button>
                            </div>
                            <div className="modal-body">
                                {modalMsg && (
                                    <div className="alert alert-warning text-center">{modalMsg}</div>
                                )}

                                {paymentChoice === null && (
                                    <div className="d-grid gap-3">
                                        <p className="text-center mb-2">Bu kursu kredi kartıyla mı almak istersiniz, yoksa kupon koduyla mı?</p>
                                        <button className="btn btn-primary" onClick={handleChooseCard}>
                                            Kredi Kartı ile Öde
                                        </button>
                                        <button className="btn btn-success" onClick={() => setPaymentChoice("coupon")}>
                                            Kupon Kodu ile Öde
                                        </button>
                                    </div>
                                )}

                                {paymentChoice === "coupon" && (
                                    <form onSubmit={handleSubmitCoupon}>
                                        <div className="mb-3">
                                            <label>{t('coupencode')}</label>
                                            <textarea
                                                className="form-control"
                                                value={couponCode}
                                                onChange={(e) => setCouponCode(e.target.value)}
                                                required
                                            />
                                        </div>
                                        <div className="d-flex gap-2">
                                            <button type="button" className="btn btn-secondary w-50" onClick={() => setPaymentChoice(null)}>
                                                Geri
                                            </button>
                                            <button type="submit" className="btn btn-success w-50" disabled={submittingCoupon}>
                                                {t("create")}
                                            </button>
                                        </div>
                                    </form>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default PackagePrice;
